/* =========================================================
   HOMEPAGE FEATURED COLLECTION - SWATCH IMAGE SWITCHER
   Purpose:
   - Clicking a swatch changes only the product card image
   - No redirect to product page
   - Only affects homepage featured collection cards
   ========================================================= */

document.addEventListener('click', function (event) {
  const swatchButton = event.target.closest(
    '.product-card-wrapper--featured .product-card-swatches__item'
  );
  if (!swatchButton) return;

  const cardWrapper = swatchButton.closest('.product-card-wrapper--featured');
  if (!cardWrapper) return;

  const mainImage = cardWrapper.querySelector('.featured-card-main-image');
  if (!mainImage) return;

  const imageUrl = swatchButton.getAttribute('data-image-url');
  const imageSrcset = swatchButton.getAttribute('data-image-srcset');
  const imageAlt = swatchButton.getAttribute('data-image-alt');

  if (imageUrl) {
    mainImage.src = imageUrl;
  }

  if (imageSrcset) {
    mainImage.srcset = imageSrcset;
  }

  if (imageAlt) {
    mainImage.alt = imageAlt;
  }

  const allSwatches = cardWrapper.querySelectorAll('.product-card-swatches__item');
  allSwatches.forEach((item) => item.classList.remove('is-active'));
  swatchButton.classList.add('is-active');
});